export class BrowserVersionUtil {

	private static readonly LATEST_CHROME_VERSION: number = 72;

	public static isBrowserIEorEdge(): boolean {
		const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
		return isIEOrEdge;
	}

	public static isBrowserIE(): boolean {
		const isIE = /msie\s|trident\//i.test(window.navigator.userAgent);
		return isIE;
	}

	public static isBrowserLegacyChrome(): boolean {
		const chromeVersion = window.navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
		if (chromeVersion) {
			try {
				return parseInt(chromeVersion[2], 10) < BrowserVersionUtil.LATEST_CHROME_VERSION;
			} catch (e) {
				console.log('Error in determining version of chrome' + e);
				return false;
			}
		}
		return false;
	}
}
